module.exports = __webpack_public_path__ + "static/media/a6-p.e2598ce9.png";